<template>
    <button
        :type="nativeType"
        :disabled="loading"
        :class="styling"
        @click="$emit('click')"
        @keyup.enter="$emit('click')"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: 'VButton',
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        nativeType: {
            type: String,
            default: 'submit',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        block: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['click'],

    computed: {
        styling() {
            return {
                button: true,
                [`is-${this.type}`]: true,
                'is-block': this.block,
                'is-large': this.large,
                'is-loading': this.loading,
            };
        },
    },
};
</script>
